const landing = {
  logoButtonLabel: 'Start TOF Persona',
  logoAlt: 'TOF logo',
  subtitle: 'Insight into working style, team dynamics and workplace.',
  languageLabel: 'Choose your language',
  cta: 'Start with yourself  →',
};

export default landing;
